<template>
  <div
    class="sheet-panel highs-lows"
    v-if="personas[personality.persona].strenghts"
  >
    <div class="sheet-header">
      <h3>Highs and lows</h3>
      <button
        class="info-tip"
        title="This section outlines your areas of excellence and areas of improvement."
        v-tippy="{ theme: 'navy' }"
      >
        <font-awesome-icon icon="info" />
      </button>
    </div>
    <div class="sheet-content">
      <div class="row">
        <div class="col-md-6 highs">
          <h3 class="blue">Highs</h3>
          <div
            class="item"
            v-bind:key="item"
            v-for="item in personas[personality.persona].strenghts"
          >
            <div class="icon">
              <font-awesome-icon :icon="strenghts[item][2]" />
            </div>
            <div class="content">
              <h4>{{ strenghts[item][0] }}</h4>
              <p>{{ strenghts[item][1] }}</p>
            </div>
          </div>
        </div>
        <div class="col-md-6 lows">
          <h3 class="blue">Lows</h3>
          <div
            class="item"
            v-bind:key="item"
            v-for="item in personas[personality.persona].weaknesses"
          >
            <div class="icon">
              <font-awesome-icon :icon="weaknesses[item][2]" />
            </div>
            <div class="content">
              <h4>{{ weaknesses[item][0] }}</h4>
              <p>{{ weaknesses[item][1] }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  personas,
  weaknesses,
  weaknesses_reduced,
  strenghts,
  strenghts_reduced,
  reporting,
} from "@/assets/static.js";
export default {
  props: {
    personality: Object,
    testLanguage: String,
  },
  data() {
    return {
      personas: personas,
      weaknesses: weaknesses,
      strenghts: strenghts,
      reporting: reporting,
    };
  },
  mounted() {
    if (this.testLanguage == "reduced") {
      this.weaknesses = weaknesses_reduced;
      this.strenghts = strenghts_reduced;
    }
  },
  methods: {},
};
</script>
